import {
  EquipmentType,
  parseEqpTypeToModality as getModality,
} from '@ifit/equipment-types';
import {
  IEquipmentType,
  IMODALITIES,
} from '@ifit/gateway-wolf-athenaeum-service';
import { useCurrentSoftwareNumber } from '../../store/software-number';

export function useModality(equipmentType: IEquipmentType): IMODALITIES {
  let modality = getModality(parseEquipmentType(equipmentType));
  const softwareNumber = useCurrentSoftwareNumber();
  if (softwareNumber === 433917) {
    modality = IMODALITIES.Yoga;
  } else if (softwareNumber === 433918) {
    modality = IMODALITIES.Strength;
  }
  return modality;
}

function parseEquipmentType(inEqType: IEquipmentType): EquipmentType {
  switch (inEqType) {
    case IEquipmentType.App:
      return EquipmentType.App;
    case IEquipmentType.Bike:
      return EquipmentType.Bike;
    case IEquipmentType.Elliptical:
      return EquipmentType.Elliptical;
    case IEquipmentType.Fusion:
      return EquipmentType.Fusion;
    case IEquipmentType.InclineTrainer:
      return EquipmentType.InclineTrainer;
    case IEquipmentType.Rower:
      return EquipmentType.Rower;
    case IEquipmentType.Shoes:
      return EquipmentType.Shoes;
    case IEquipmentType.StationaryBike:
      return EquipmentType.StationaryBike;
    case IEquipmentType.Stepper:
      return EquipmentType.Stepper;
    case IEquipmentType.Strength:
      return EquipmentType.Strength;
    case IEquipmentType.Strider:
      return EquipmentType.Strider;
    case IEquipmentType.StudioBike:
      return EquipmentType.StudioBike;
    case IEquipmentType.TDFBike:
      return EquipmentType.TDFBike;
    case IEquipmentType.Treadmill:
      return EquipmentType.Treadmill;
    case IEquipmentType.Wearable:
      return EquipmentType.Wearable;
    default:
      return EquipmentType.Strength;
  }
}
